(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lux-directory"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-lux-directory-search]')) return;
    const section = event.target.closest('.lux-directory');
    const query = event.target.value.trim().toLowerCase();
    let visibleCount = 0;
    section.querySelectorAll('[data-lux-directory-group]').forEach((group) => {
      let groupCount = 0;
      group.querySelectorAll('[data-lux-directory-item]').forEach((item) => {
        const matches = query === '' || item.textContent.toLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) groupCount += 1;
      });
      group.hidden = groupCount === 0;
      visibleCount += groupCount;
    });
    section.querySelector('[data-lux-directory-empty]').hidden = visibleCount > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
